var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({class:['star', { 'star--small': _vm.isSmall }],attrs:{"width":(_vm.width + "px"),"height":(_vm.height + "px"),"viewBox":"0 0 21 19","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},_vm.$listeners),[_c('polygon',{class:[
      'star__polygon',
      {
        'star__polygon--inactive': _vm.isInactive,
        'star__polygon--empty': _vm.hasBorderOnly,
        'star__polygon--alert': _vm.hasAlert,
      } ],attrs:{"points":"11.1,15.4 5.5,18.3 6.5,12.1 2,7.7 8.3,6.8 11.1,1.2 13.9,6.8 20.2,7.7 15.7,12.1 16.7,18.3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }